import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useRef } from "react";
import { useState } from "react";
import PageTitle from "../../../../components/partials/PageTitle";
import {
  createCustomerSavingsPolicy,
  resetPolicyStatus,
} from "../../../../redux/slice/policy/savingsPolicy/savingsPolicySlice";
import PreviewSavingsPolicyAppSchedule from "./PreviewSavingsPolicyAppSchedule";
import { BsPencilFill } from "react-icons/bs";
import { ImBin } from "react-icons/im";

const PreviewSavingsPolicyApplication = () => {
  const {
    temp_policy_attach_data,
    active_savings_policies,
    isUpdated,
    isLoading,
    customer_policy_details,
    covers,
  } = useSelector((state) => state.savingsPolicy);
  // const { user_permissions } = useSelector((state) => state?.auth?.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const previewPaySchedule = useRef();

  const breadcrumb = {
    from: {
      title: "policy",
      link: "/admin/savings-policy-application",
    },
    current: {
      title: "Savings application preview",
      link: null,
    },
  };

  // const payload = {
  //   ...temp_policy_attach_data,
  //   // sum_assured: temp_policy_attach_data.total_premium,
  // };

  //   useEffect(() => {
  //     if (
  //       !user_permissions?.some(
  //         (permission) => permission.name === "customer module"
  //       )
  //     ) {
  //       navigate("/admin/dashboard");
  //     }
  //   }, [navigate, user_permissions]);

  useEffect(() => {
    if (isUpdated) {
      if (customer_policy_details?.policy_app_details?.policyAppNumber) {
        previewPaySchedule?.current?.click();
      }
      dispatch(resetPolicyStatus());
    }
  }, [isUpdated]);

  return (
    <>
      {/* page title */}
      <PageTitle title='Policy Application Preview' breadcrumb={breadcrumb} />
      {/* end page title */}

      <div className='row'>
        <div className='col-md-12'>
          <div className='card'>
            <div className='card-body'>
              <div className='row'>
                <div className='col-md-12 row'>
                  <h5 className='text-primary-1 my-2 text-uppercase'>
                    Investment Information
                  </h5>
                  <div className='mb-3'>
                    <label htmlFor='policy' className='form-label'>
                      Policy Name
                    </label>
                    <input
                      type='text'
                      className={`form-control form-control-sm text-capitalize`}
                      defaultValue={
                        active_savings_policies.savings_policy.find(
                          (item) =>
                            item.id ==
                            temp_policy_attach_data?.savings_policy_id
                        )?.name
                      }
                      readOnly
                    />
                  </div>
                </div>

                <div className='col-md-12 row mb-3'>
                  <div className='col-md-4'>
                    <label htmlFor='policy_name' className='form-label'>
                      Repayment Frequency
                    </label>
                    <input
                      type='text'
                      className={`form-control form-control-sm mb-3`}
                      value={temp_policy_attach_data?.repayment_frequency}
                      readOnly
                    />
                  </div>
                  <div className='col-md-4'>
                    <label htmlFor='policy_name' className='form-label'>
                      Sum Assured
                    </label>
                    <input
                      type='number'
                      className={`form-control form-control-sm mb-3`}
                      value={temp_policy_attach_data?.sum_assured}
                      readOnly
                    />
                  </div>
                  <div className='col-md-4'>
                    <label htmlFor='policy_name' className='form-label'>
                      Rate
                    </label>
                    <input
                      type='number'
                      className={`form-control form-control-sm mb-3`}
                      value={temp_policy_attach_data?.interest_rate}
                      readOnly
                    />
                  </div>
                  <div className='col-md-4'>
                    <label htmlFor='policy_name' className='form-label'>
                      Premium/Contribution
                    </label>
                    <input
                      type='number'
                      className={`form-control form-control-sm mb-3`}
                      value={temp_policy_attach_data?.premuim_contribution}
                      readOnly
                    />
                  </div>
                  <div className='col-md-4' style={{ marginTop: "28px" }}>
                    <a
                      href={temp_policy_attach_data?.proposal_document}
                      target='_blank'
                      className='btn btn-sm btn-primary text-white d-flex gap-2 align-items-center align-content-center justify-content-center'
                    >
                      View Proposal Form
                      <i className='mdi mdi-eye text-white fs-5'></i>
                    </a>
                  </div>
                </div>
                <div className='col-md-12 mb-3'>
                  <h5 className='text-primary-1 mb-2 text-uppercase'>
                    Risk Covered Information
                  </h5>
                  <div>
                    <label
                      htmlFor='covers'
                      className='form-label shadow-sm p-1'
                    >
                      <span className='fw-bold'>Life Cover Name: </span>
                      {covers?.get_life_covers.length &&
                        covers?.get_life_covers[0]?.life_cover_name}
                    </label>
                    {temp_policy_attach_data?.covers?.length ? (
                      <table className='table table-centered table-striped nowrap w-100 no-footer'>
                        <thead>
                          <tr>
                            <th
                              className='sorting'
                              tabIndex='0'
                              rowSpan='1'
                              colSpan='1'
                              style={{ width: "140.8px" }}
                              aria-label='Customer: activate to sort column ascending'
                            >
                              Other Cover
                            </th>
                            <th
                              className='sorting'
                              tabIndex='0'
                              rowSpan='1'
                              colSpan='1'
                              style={{ width: "5.8px" }}
                              aria-label='Customer: activate to sort column ascending'
                            >
                              Rate(%)
                            </th>
                            <th
                              className='sorting'
                              tabIndex='0'
                              rowSpan='1'
                              colSpan='1'
                              style={{ width: "140.8px" }}
                              aria-label='Phone: activate to sort column ascending'
                            >
                              sum Assured
                            </th>
                            <th
                              className='sorting'
                              tabIndex='0'
                              rowSpan='1'
                              colSpan='1'
                              style={{ width: "147.8px" }}
                            >
                              Premium
                            </th>
                            <th
                              className='sorting'
                              tabIndex='0'
                              rowSpan='1'
                              colSpan='1'
                              style={{ width: "257.8px" }}
                              aria-label='Email: activate to sort column ascending'
                            >
                              Detail Description
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          {temp_policy_attach_data?.covers?.map((item, i) => (
                            <tr key={i}>
                              <td className='text-capitalize'>
                                {
                                  covers?.get_other_cover?.filter(
                                    (p) => p.id === item?.cover_id
                                  )[0]?.cover_name
                                }
                              </td>
                              <td className='table-user'>{item?.rate}</td>
                              <td className='table-user'>
                                {item?.sum_assured}
                              </td>
                              <td className='text-dark'>
                                {parseFloat(
                                  (item?.rate * item?.sum_assured) / 100
                                )?.toFixed(2)}
                              </td>
                              <td>{item?.desc}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : null}
                  </div>
                </div>
                <div className='col-md-12 mb-3'>
                  <h5 className='text-primary-1 mb-2 text-uppercase'>
                    Premium Information
                  </h5>
                  <div className='col-md-4'>
                    <label htmlFor='policy_name' className='form-label'>
                      Total Premium
                    </label>
                    <input
                      type='text'
                      className={`form-control form-control-sm mb-3`}
                      value={temp_policy_attach_data?.total_sum_assured}
                      readOnly
                    />
                  </div>
                </div>

                <div className='col-md-12 mb-3 d-none'>
                  <div style={{ width: "180px" }}>
                    <span
                      className='btn btn-sm btn-primary text-white d-flex gap-2 align-items-center align-content-center justify-content-center'
                      data-bs-toggle='modal'
                      data-bs-target='#preview-schedule'
                      ref={previewPaySchedule}
                    >
                      Preview Schedule
                      <i className='mdi mdi-eye text-white fs-5'></i>
                    </span>
                  </div>
                </div>

                <div className='row'>
                  <div className='mt-4 d-flex justify-content-end'>
                    <button
                      type='button'
                      className='btn btn-info text-white me-2'
                      onClick={() => navigate(-1)}
                    >
                      <i className='mdi mdi-arrow-left me-1'></i>
                      Previous
                    </button>
                    <button
                      type='submit'
                      className='btn btn-primary text-white px-3'
                      onClick={() => {
                        dispatch(
                          createCustomerSavingsPolicy(temp_policy_attach_data)
                        );
                      }}
                      disabled={isLoading}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          {/* preview modal */}
          <PreviewSavingsPolicyAppSchedule
            modal_id='preview-schedule'
            policyID={temp_policy_attach_data?.savings_policy_id}
            data={{
              ...temp_policy_attach_data,
              sum_assured: temp_policy_attach_data?.total_sum_assured,
            }}
            policyDetails={customer_policy_details?.policy_app_details}
          />
        </div>
      </div>
    </>
  );
};

export default PreviewSavingsPolicyApplication;
